export default {
    TOGGLE_STATUS: 'TOGGLE_STATUS',
}